import { createId } from '@paralleldrive/cuid2'

const RESOURCE_PREFIX_MAP = {
  agentRun: 'agr',
  address: 'adr',
  app: 'app',
  appInstallation: 'appinst',
  appCommunicationChannel: 'appcomm',
  appResourceInstance: 'appri',
  appCrmMap: 'appcrm',
  admission: 'adm',
  batchJob: 'bj',
  batchJobAction: 'bja',
  batchJobTask: 'bjtsk',
  campaign: 'cmp',
  campaignGoal: 'cmpg',
  campaignParticipant: 'cmpp',
  checkout: 'chk',
  communicationChannel: 'comm',
  communicationChannelSubscription: 'commsub',
  component: 'comp',
  contact: 'cnt',
  contactAssociation: 'cntassoc',
  contactBlock: 'cntblk',
  chat: 'cht',
  chatMessage: 'msg',
  messageAttachment: 'msgatt',
  crmMigration: 'crmmig',
  crmOperation: 'crmop',
  customer: 'cus',
  customResource: 'cr',
  customResourceModel: 'crm',
  dependant: 'dep',
  dependantLineAssignment: 'dl',
  deployment: 'dpl',
  executable: 'exe',
  draftOrder: 'dr',
  file: 'fl',
  import: 'imp',
  instance: 'ins',
  instanceActivity: 'insact',
  invoice: 'inv',
  invoiceLine: 'ivl',
  line: 'ln',
  location: 'loc',
  member: 'mb',
  metafieldDefinitionOption: 'mfo',
  notificationTemplate: 'nt',
  notification: 'not',
  order: 'ord',
  page: 'pg',
  payout: 'po',
  product: 'prd',
  variant: 'var',
  request: 'req',
  record: 'rec',
  recordUniqueValue: 'recuniq',
  recordActivity: 'recact',
  refund: 'rf',
  refundLine: 'rfl',
  service: 'srv',
  space: 'spc',
  taxLine: 'tl',
  taxRate: 'tr',
  terminalReader: 'trm',
  transaction: 'txn',
  workplace: 'wrk',
  metafield: 'mf',
  pageComponent: 'pgcomp',
  metafieldValue: 'mfv',
  workflow: 'wf',
  workflowRun: 'wfrun',
  workflowVersion: 'wfver',
  agent: 'ag',
  agentVersion: 'agver',
  agentTool: 'tool',
  trigger: 'trg',
  model: 'mdl',
  field: 'fld',
  fieldDefinition: 'def',
  fieldDefinitionOption: 'defopt',
  fieldSection: 'fldsec',
  fieldComponentType: 'fldcomp',
  relationship: 'rel',
  relationshipLink: 'rellink',
  provision: 'prov',
  webhook: 'wh',
  webhookRegistration: 'whreg',
  // Thread-based communication system
  thread: 'thd',
  threadMessage: 'thdmsg',
  threadMessageAttachment: 'thdatt',
  threadParticipant: 'thdpart',
  threadReadCursor: 'thdcur',
  participant: 'part',
  channelBinding: 'chbind',
  threadContext: 'thdctx',
  threadLink: 'thdlink',
  // Stage 4: Organization
  threadTopic: 'thdtpc',
  messageTopic: 'msgtpc',
  messageTag: 'msgtag',
  messageTagAssignment: 'msgtagasn',
  decisionType: 'dectype',
  threadDecision: 'thddec',
  threadSummary: 'thdsum',
  // Stage 5: Search & AI
  messageEmbedding: 'msgemb',
  // Stage 6: Advanced Features
  callSession: 'call',
  callParticipant: 'callpart',
  messageReaction: 'msgrxn',
  messageMention: 'msgmnt',
  // Thread Hooks System
  playbook: 'pb',
  playbookHook: 'pbhook',
  threadWorkflowRun: 'thdwfrun',
  threadBlock: 'thdblk',
  // Scheduled Messages
  scheduledMessage: 'schdmsg',
} as const

export type ResourceKey = keyof typeof RESOURCE_PREFIX_MAP

export const generateDBId = (resource: ResourceKey | undefined): string => {
  if (!resource) {
    return createId()
  }
  return `${RESOURCE_PREFIX_MAP[resource]}_${createId()}`
}
